import { render, staticRenderFns } from "./AdministrativePayrollTracking.vue?vue&type=template&id=64472993"
import script from "./AdministrativePayrollTracking.vue?vue&type=script&lang=js"
export * from "./AdministrativePayrollTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports